"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var addDays = function addDays(date, days) {
  return (0, _dayjs["default"])(date).add(days || 0, 'day').toISOString();
};

var _default = addDays;
exports["default"] = _default;